import React from "react";

export default function PreferencesStep({ data, onChange, firstFieldRef }) {
  return (
    <>
      <p className="text-xs text-marine/80 mb-1">Optionnel — des valeurs par défaut raisonnables sont déjà appliquées.</p>
      <label className="flex items-center gap-2 text-sm text-marine cursor-pointer">
        <input ref={firstFieldRef} type="checkbox" checked={data.email_notifications !== false}
          onChange={(e) => onChange({ ...data, email_notifications: e.target.checked })} />
        Recevoir des notifications par e-mail (rappels, mises à jour de projet)
      </label>
      <fieldset>
        <legend className="block text-sm font-semibold text-marine mb-1 mt-3">Canal de contact préféré</legend>
        <div className="space-y-1.5">
          {[{ v: "email", l: "E-mail" }, { v: "phone", l: "Téléphone" }].map((opt) => (
            <label key={opt.v} className="flex items-center gap-2 text-sm text-marine cursor-pointer">
              <input type="radio" name="onb-preferred-channel" checked={(data.preferred_contact_channel || "email") === opt.v}
                onChange={() => onChange({ ...data, preferred_contact_channel: opt.v })} /> {opt.l}
            </label>
          ))}
        </div>
      </fieldset>
    </>
  );
}
